import { InfoCircleOutlined } from "@ant-design/icons";
import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/rootReducer";

const tClass = "text-black text-opacity-50 text-xs";

function ConfirmData() {
  const { masterColumns, newFile } = useSelector(
    (state: RootState) => state.salesData,
  );

  const isMissingMappingExists = () =>
    masterColumns.some((item) => item.rawColumn === "");

  return (
    <div>
      {isMissingMappingExists() && (
        <div className="flex bg-jasmine px-2.5 py-2 items-center gap-2.5 rounded-sm">
          <InfoCircleOutlined />
          <div className="text-maastricht-blue text-xs">
            All columns are not mapped. Please make sure the column mappings are
            correct before processing data.
          </div>
        </div>
      )}
      <div className="default-border bg-lotion px-4 py-2.5 my-2.5">
        <div className={tClass}>File Name</div>
        <div>{newFile.title}</div>
        <div className={tClass}>Size</div>
        <div>{newFile.file_size} kb</div>
        <div className={tClass}>Uploaded</div>
        {/* 2021-04-21 15:05 */}
        <div>{moment(newFile.created_at).format("YYYY-MM-DD hh:mm a")}</div>
      </div>
      <div className="default-border bg-lotion px-4 py-2.5 my-2.5">
        {newFile.from_date && (
          <>
            <div className={tClass}>Period</div>
            <div>
              {newFile.from_date} ~ {newFile.to_date}
            </div>
          </>
        )}
        <div className={tClass}>Currency Type</div>
        <div>{newFile.currency_name}</div>
        <div className={tClass}>Platform</div>
        <div>{newFile.platform_name}</div>
        {newFile.distributor && (
          <>
            <div className={tClass}>Distributor</div>
            <div>{newFile.distributor_name}</div>
          </>
        )}
        {newFile.comment && (
          <>
            <div className={tClass}>Comment</div>
            <div>{newFile.comment}</div>
          </>
        )}
      </div>
    </div>
  );
}

export default ConfirmData;
